import { maybeQualifyURL } from '../../../../../qualifyURL';

function transform(_tagName, attribs) 
{
    const attributes = {
        tagName: 'link',
        attribs: { ...attribs },
    };

    if (attribs.href) 
    {
        attributes.attribs.href = maybeQualifyURL(attribs.href);
    }
    else 
    {
        return { value: false };
    }

    return attributes;
}

const allowedAttributes = ['rel', 'href'];

export default {
    allowedAttributes,
    transform,
};
